module.exports = __webpack_public_path__ + "static/media/PDF.b823a606.svg";